@if (statuses.length !== 0) {
<div class="status-section">
  <h2>
    Milestone progress
    <small>
      <icon type="exclamation-triangle"></icon>
      needs to be updated manually</small
    >
  </h2>
  @for (status of statuses; track status) {
  <div class="my-5">
    <strong> {{ status.label || '-' }}</strong>
    <milestones
      [milestones]="toMilestonesModel(status.milestones)"
      [initialValue]="findCurrentMilestoneId(status.milestones)"
      [disabled]="status.disabled"
      (update)="
        updateMilestoneStatus(status.collection_id, status.element_id, $event)
      "
    ></milestones>
  </div>
  }
</div>
}
